import { pdfjs } from "react-pdf";

// Bundle the real worker instead of loading it by URL at runtime. Loading tasks
// receive the PDFWorker explicitly, so React-PDF will not destroy this shared
// worker while another document is starting to load.
pdfjs.GlobalWorkerOptions.workerPort = null;

const workerPort = new Worker(
    new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url),
    { type: "module" },
);

export const pdfDocumentOptions = Object.freeze({
    worker: pdfjs.PDFWorker.create({ port: workerPort }),
});
